import { Connection, ConnectionMonitor } from '../model/entities';
import { Page } from '../model/elements';
import adminApiAxios from './CustomAxios';
import moment from 'moment';
import providerAuthService from '../services/ProviderAuthService';

class ConnectionMonitorApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        connectionId: number,
    ): Promise<Page<ConnectionMonitor>> => {
        const response = await adminApiAxios.get<Page<ConnectionMonitor>>('/connection-monitors', {
            params: { page, size, sortField, sortOrder, connectionId },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((connectionMonitor) => this.loadDates(connectionMonitor));

        return response.data;
    };

    get = async (id: number): Promise<ConnectionMonitor> => {
        const response = await adminApiAxios.get<ConnectionMonitor>(`/connection-monitors/${id}`);
        this.loadDates(response.data);
        return response.data;
    };

    create = async (connectionMonitor: ConnectionMonitor, connection: Connection): Promise<ConnectionMonitor> => {
        const headers = await providerAuthService.getRequestHeader(connection.source?.provider!);
        const response = await adminApiAxios.post<ConnectionMonitor>('/connection-monitors', connectionMonitor, {
            headers,
        });
        this.loadDates(response.data);
        return response.data;
    };

    update = async (connectionMonitor: ConnectionMonitor, connection: Connection): Promise<ConnectionMonitor> => {
        const headers = await providerAuthService.getRequestHeader(connection.source?.provider!);
        const response = await adminApiAxios.put<ConnectionMonitor>(
            `/connection-monitors/${connectionMonitor.id}`,
            connectionMonitor,
            { headers },
        );
        this.loadDates(response.data);
        return response.data;
    };

    delete = async (connectionMonitor: ConnectionMonitor, connection: Connection): Promise<void> => {
        const headers = await providerAuthService.getRequestHeader(connection.source?.provider!);
        await adminApiAxios.delete(`/connection-monitors/${connectionMonitor.id}`, { headers });
    };

    /**
     * Loads the dates of a connection monitor.
     * @param connectionMonitor - the connection monitor
     */
    private loadDates(connectionMonitor: ConnectionMonitor) {
        connectionMonitor.audit!.created =
            connectionMonitor.audit!.created && moment.utc(connectionMonitor.audit!.created).local();
        connectionMonitor.audit!.updated =
            connectionMonitor.audit!.updated && moment.utc(connectionMonitor.audit!.updated).local();
    }
}

const connectionMonitorApi: ConnectionMonitorApi = new ConnectionMonitorApi();
export default connectionMonitorApi;
